<template>
    <div class="card">
        <div
            class="card-header"
        >{{ $t('createShipment.label.Shipment Options') }}</div>
        <div class="card-body">
            <b-col sm="12">
                <b-row>
                    <b-col sm="6">
                        <b-form-group label-cols-sm="4"
                                      :label="$t('createShipment.label.Ship date')"
                                      label-align-sm="left"
                                      label-for="shipAt">
                            <b-input-group size="sm">
                                <b-col sm="10">
                                    <Datepicker v-model="shipment.shipDate"
                                                input-class="form-control form-control-sm"
                                                :disabled-dates="disabledDates"
                                                :monday-first="true"
                                                id="shipAt"
                                                :typeable="false"
                                                name="shipDatePicker"
                                                :use-utc="false"
                                                :format="formatDate"
                                                ref="datePicker" />
                                </b-col>
                                <b-input-group-append>
                                    <div>
                                        <requiredIcon />
                                    </div>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group label-cols-sm="3"
                                      :label="$t('createShipment.label.ReturnShipment')"
                                      label-align-sm="left"
                                      label-for="returnShipment"
                                      v-if="display(fieldNames.RETURN_SHIPMENT)">
                            <b-input-group size="sm">
                                <b-col sm="9">
                                    <b-form-checkbox class="float-left"
                                                     size="sm"
                                                     name="returnShipmentCheckbox"
                                                     v-model="shipment.shipmentOptions.returnShipment"></b-form-checkbox>
                                </b-col>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row
                    v-if="isCustomsShipment(shipment.receiverAddress, shipment.pickupAddress)"
                >
                    <b-col sm="6">
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createShipment.label.Document')"
                            label-align-sm="left"
                            label-for="isDocument"
                        >
                            <b-input-group size="sm">
                                <b-col sm="10">
                                    <b-form-checkbox
                                        class="float-left"
                                        size="sm"
                                        name="documentCheckbox"
                                        v-model="shipment.shipmentOptions.isDocument"
                                        @change="setIsDocument()"
                                    ></b-form-checkbox>
                                </b-col>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="displayCustoms">
                    <b-col sm="6">
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createShipment.label.Customs Value')"
                            label-align-sm="left"
                            label-for="customValue"
                        >
                            <b-input-group size="sm">
                                <b-col sm="10">
                                    <b-form-input
                                        id="customValue"
                                        v-model.number="shipment.customsAmount.amount"
                                        size="sm"
                                        name="shipment.customsAmount.amount"
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        :class="{
                                            'is-invalid': hasBackendValidationError(
                                                'ShipmentOptionsValidation_CustomsAmountMinMaxError'
                                            )
                                        }"
                                    />
                                    <validationField
                                        fieldName="createShipment.label.Customs Value"
                                        :validator="v.shipment.customsAmount.amount"
                                        name="shipment.customsAmount.amount.error"
                                    />
                                </b-col>
                                <b-input-group-append>
                                    <div>
                                        <requiredIcon
                                            :active="hasShipmentOptions"
                                        />
                                    </div>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            label-cols-sm="3"
                            :label="$t('createShipment.label.Currency')"
                            label-align-sm="left"
                            label-for="customValuta"
                        >
                            <b-input-group size="sm">
                                <b-col sm="10">
                                    <vSelect
                                        :dynamicWidth="true"
                                        :options="getCurrencies"
                                        :select-on-tab="true"
                                        :placeholder="
                                            $t('createShipment.placeholder.Choose Currency')
                                        "
                                        :reduce="(currency) => currency.currencyCode"
                                        label="currencyName"
                                        v-model="shipment.customsAmount.currencyCode"
                                        name="customsCurrencyDropdown"
                                        aria-describedby="customs-currency-feedback"
                                        :class="{
                                            'is-invalid': hasBackendValidationError(
                                                'ShipmentOptionsValidation_CustomsCurrencyRequired'
                                            )
                                        }"
                                    />
                                    <validationField
                                        fieldName="createShipment.label.Currency"
                                        :validator="v.shipment.customsAmount.currencyCode"
                                        name="customsCurrencyDropdown.error"
                                    />
                                </b-col>
                                <b-input-group-append>
                                    <div>
                                        <requiredIcon
                                            :active="hasShipmentOptions"
                                        />
                                    </div>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="!displayCustoms">
                  <b-col sm="6">
                    <b-form-group
                        label-cols-sm="4"
                        label="Shipment Value"
                        label-align-sm="left"
                        label-for="shipmentValue"
                    >
                      <b-input-group size="sm">
                        <b-col sm="10">
                          <b-form-input
                              id="shipmentValue"
                              v-model.number="shipment.shipmentAmount.amount"
                              size="sm"
                              name="shipment.shipmentAmount.amount"
                              type="number"
                              step="0.01"
                              min="0"
                              :class="{
                                            'is-invalid': hasBackendValidationError(
                                                'ShipmentOptionsValidation_shipmentAmountMinMaxError'
                                            )
                                        }"
                          />
                        </b-col>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                        label-cols-sm="3"
                        :label="$t('createShipment.label.Currency')"
                        label-align-sm="left"
                        label-for="customValuta"
                    >
                      <b-input-group size="sm">
                        <b-col sm="10">
                          <vSelect
                              :dynamicWidth="true"
                              :options="getCurrencies"
                              :select-on-tab="true"
                              :placeholder="
                                            $t('createShipment.placeholder.Choose Currency')
                                        "
                              :reduce="(currency) => currency.currencyCode"
                              label="currencyName"
                              v-model="shipment.shipmentAmount.currencyCode"
                              name="shipmentCurrencyDropdown"
                              aria-describedby="shipment-currency-feedback"
                              :class="{'is-invalid': !shipment.shipmentAmount.currencyCode && shipment.shipmentAmount.amount > 0 }"
                          />
                          <validationField
                              fieldName="createShipment.label.Currency"
                              :validator="v.shipment.customsAmount.currencyCode"
                              name="customsCurrencyDropdown.error"
                          />
                        </b-col>
                        <b-input-group-append>
                          <div>
                            <requiredIcon
                                :active="hasShipmentOptions"
                            />
                          </div>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="canInsure">
                    <b-col sm="6">
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createShipment.label.No Insurance')"
                            label-align-sm="left"
                            label-for="insuranceValue"
                            v-if="
                                display(fieldNames.INSURANCE) &&
                                    display(fieldNames.NO_INSURANCE) &&
                                    !isReceiverPays
                            "
                        >
                            <b-input-group size="sm">
                                <b-col sm="10">
                                    <b-form-checkbox
                                        class="float-left"
                                        size="sm"
                                        name="noInsuranceCheckbox"
                                        v-model="isInsuranceAmountRequired"
                                    ></b-form-checkbox>
                                </b-col>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                
                <b-row
                    v-if="!insurance.isInsurance && !isReceiverPays && !isInsuranceAmountRequired && canInsure"
                >
                    <b-col sm="6">
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createShipment.label.Insurance Value')"
                            label-align-sm="left"
                            label-for="insuranceValue"
                            v-if="display(fieldNames.INSURANCE)"
                        >
                            <b-input-group size="sm">
                                <b-col sm="10">
                                    <b-form-input
                                        id="insuranceValue"
                                        v-model.number="shipment.insuranceAmount.amount"
                                        size="sm"
                                        type="number"
                                        min="0"
                                        name="insuranceValueInput"
                                        :class="{
                                            'is-invalid': hasBackendValidationError(
                                                'ShipmentOptionsValidation_InsuranceAmountMinMaxError'
                                            )
                                        }"
                                        aria-describedby="insuranceValue-feedback"
                                        @update="v.shipment.insuranceAmount.amount.$touch()"
                                    />
                                    <validationField
                                        v-if="v.shipment.insuranceAmount.amount.$dirty"
                                        fieldName="createShipment.label.Insurance Value"
                                        :validator="v.shipment.insuranceAmount.amount"
                                        name="insuranceValueInput.error"
                                    />
                                </b-col>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col v-if="display(fieldNames.INSURANCE)">
                        <b-form-group
                            label-cols-sm="3"
                            :label="$t('createShipment.label.Currency')"
                            label-align-sm="left"
                            label-for="insuranceValuta"
                        >
                            <b-input-group size="sm">
                                <b-col sm="10">
                                    <vSelect
                                        :dynamicWidth="true"
                                        :options="getListOfInsuranceCurrencies"
                                        :select-on-tab="true"
                                        :placeholder="
                                            $t('createShipment.placeholder.Choose Currency')
                                        "
                                        :reduce="(currency) => currency.currencyCode"
                                        label="currencyName"
                                        v-model="shipment.insuranceAmount.currencyCode"
                                        name="insuranceCurrencyDropdown"
                                        :class="{
                                            'is-invalid': hasBackendValidationError(
                                                'ShipmentOptionsValidation_InsuranceCurrencyRequired'
                                            )
                                        }"
                                    />
                                    <validationField
                                        fieldName="createShipment.label.Currency"
                                        :validator="v.shipment.insuranceAmount.currencyCode"
                                        name="insuranceCurrencyDropdown.error"
                                    />
                                </b-col>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
              <b-row v-if="!insurance.isInsurance && !isReceiverPays && !isInsuranceAmountRequired && canInsure">
                <b-col sm="6">
                  <b-form-group
                      label-cols-sm="4"
                      label=""
                      label-align-sm="left"
                      v-if="display(fieldNames.INSURANCE)"
                  >
                    <b-input-group size="sm">
                      <b-col sm="10">
                        <a :href="$t('createShipment.url.InsuranceTerms')" target="_blank" style="position:relative; top:5px;text-decoration: underline;">Show Insurance Terms</a>
                      </b-col>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group
                      label-cols-sm="4"
                      :label="$t('createShipment.label.Accept Insurance Terms')"
                      label-align-sm="left"
                      v-if="display(fieldNames.INSURANCE) && !display(fieldNames.NO_INSURANCE) "
                  >
                    <b-input-group size="sm">
                      <b-col sm="10">
                        <b-form-checkbox
                            class="float-left"
                            size="sm"
                            name="insuranceTermsCheckbox"
                            v-model="shipment.insuranceAmount.termsAccepted"
                        ></b-form-checkbox>

                      </b-col>

                    </b-input-group>

                  </b-form-group>
                  <validationField
                      fieldName="createShipment.label.Accept Insurance Terms"
                      :validator="v.shipment.insuranceAmount.termsAccepted"
                      error-text="errors.InsuranceTermsAccept"
                      name="v.shipment.insuranceTerms.$error"
                  />
                </b-col>
              </b-row>
                <b-row v-if="shipment.shipmentType !== 'Import'">
                    <b-col sm="6">
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createShipment.label.Receiver Pays')"
                            label-align-sm="left"
                            v-if="display(fieldNames.RECEIVER_PAYS)"
                        >
                            <b-input-group size="sm">
                                <b-col sm="10">
                                    <b-form-checkbox
                                        class="float-left"
                                        size="sm"
                                        name="receiverPaysCheckbox"
                                        v-model="isReceiverPays"
                                    ></b-form-checkbox>
                                </b-col>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="isReceiverPays">
                    <b-col sm="6">
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createShipment.label.Transport Product')"
                            label-align-sm="left"
                        >
                            <b-input-group size="sm">
                                <b-col sm="10">
                                    <v-Select
                                        :dynamicWidth="true"
                                        :options="getReceiverPaysTransportProducts"
                                        :select-on-tab="true"
                                        label="internalName"
                                        :reduce="(p) => p.transportProductId"
                                        name="receiverPaysProductList"
                                        :placeholder="
                                            $t('createShipment.placeholder.Choose Product')
                                        "
                                        v-model="shipment.receiverPays.transportProduct"
                                        @update="v.shipment.receiverPays.transportProduct.$touch()"
                                        :class="{
                                            'is-invalid':
                                                v.shipment.receiverPays.transportProduct.$error
                                        }"
                                    />
                                    <validationField
                                        fieldName="createShipment.label.Transport Product"
                                        :validator="v.shipment.receiverPays.transportProduct"
                                        name="receiverPaysProductList.error"
                                        v-if="v.shipment.receiverPays.transportProduct.$error"
                                    />
                                </b-col>
                                <b-input-group-append>
                                    <div>
                                        <font-awesome-icon
                                            icon="exclamation-circle"
                                            size="lg"
                                        />
                                    </div>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            label-cols-sm="3"
                            :label="$t('createShipment.label.Account Number')"
                            label-align-sm="left"
                        >
                            <b-input-group size="sm">
                                <b-col sm="10">
                                    <b-form-input
                                        size="sm"
                                        type="text"
                                        name="shipment.receiverPays.accountNumber"
                                        v-model="shipment.receiverPays.accountNumber"
                                        @update="v.shipment.receiverPays.accountNumber.$touch()"
                                    />
                                    <validationField
                                        fieldName="createShipment.label.Account Number"
                                        :validator="v.shipment.receiverPays.accountNumber"
                                        name="shipment.receiverPays.accountNumber.error"
                                        v-if="v.shipment.receiverPays.accountNumber.$error"
                                    />
                                </b-col>
                                <b-input-group-append>
                                    <div>
                                        <font-awesome-icon
                                            icon="exclamation-circle"
                                            size="lg"
                                        />
                                    </div>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="6">
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createShipment.label.Importer of Record')"
                            label-align-sm="left"
                            v-if="display(fieldNames.IMPORTER_OF_RECORD)"
                        >
                            <b-input-group size="sm">
                                <b-col sm="10">
                                    <b-form-input
                                        id="importOfRecord"
                                        :placeholder="
                                            $t('createShipment.placeholder.ImportOfRecord')
                                        "
                                        name="shipment.shipmentOptions.importerOfRecord"
                                        v-model="shipment.shipmentOptions.importerOfRecord"
                                        size="sm"
                                        type="text"
                                    />
                                </b-col>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="6">
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createShipment.label.Export Reason')"
                            label-align-sm="left"
                            v-if="display(fieldNames.EXPORT_REASONS)"
                        >
                            <b-input-group size="sm">
                                <b-col sm="10">
                                    <vSelect
                                        :dynamicWidth="true"
                                        :options="getExportReasons"
                                        :select-on-tab="true"
                                        :placeholder="
                                            $t('createShipment.placeholder.Choose Reason')
                                        "
                                        label="exportReasonCodeName"
                                        :reduce="
                                            (exportReason) => exportReason.exportReasonCodeName
                                        "
                                        v-model="shipment.shipmentOptions.exportReason"
                                    />
                                </b-col>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col 
                        sm="6" 
                        v-if="
                        isCustomsShipmentAndNotDocument(
                            shipment.shipmentOptions.isDocument,
                            shipment.pickupAddress,
                            shipment.receiverAddress,
                            shipment.shipDate
                        )"
                    >
                        <b-form-group
                            label-cols-sm="3"
                            :label="$t('createShipment.label.Incoterms')"
                            label-align-sm="left"
                            :name="fieldNames.INCOTERMS"
                            v-if="display(fieldNames.INCOTERMS)"
                        >
                            <b-input-group size="sm">
                                <b-col sm="10">
                                    <vSelect
                                        :dynamicWidth="true"
                                        :options="getListOfIncoterms"
                                        :select-on-tab="true"
                                        :placeholder="
                                            $t('createShipment.placeholder.Choose Incoterms')
                                        "
                                        :reduce="(incoterm) => incoterm.incotermName"
                                        label="incotermName"
                                        v-model="shipment.shipmentOptions.incoterms"
                                        name="incotermsDropdown"
                                    />
                                </b-col>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="isCustomsShipmentAndNotDocument(
                            shipment.shipmentOptions.isDocument,
                            shipment.pickupAddress,
                            shipment.receiverAddress,
                            shipment.shipDate
                        )">
                  <b-col sm="6">
                    <b-form-group
                        label-cols-sm="4"
                        :label="$t('createShipment.label.SoldTo')"
                        label-align-sm="left"
                        :name="fieldNames.SOLDTO"
                        v-if="display(fieldNames.SOLDTO)"
                    >
                      <b-input-group size="sm">
                          <b-col sm="10">
                            <b-form-checkbox
                                class="float-left"
                                size="sm"
                                name="receiverPaysCheckbox"
                                v-model="isSoldTo"
                            ></b-form-checkbox>
                          </b-col>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6">
                    <b-form-group
                        label-cols-sm="4"
                        :label="$t('createShipment.label.Broker')"
                        label-align-sm="left"
                        :name="fieldNames.BROKER"
                        v-if="display(fieldNames.BROKER)"
                    >
                      <b-input-group size="sm">
                        <b-col sm="10">
                          <b-form-checkbox
                              class="float-left"
                              size="sm"
                              name="brokerCheckbox"
                              v-model="isBroker"
                          ></b-form-checkbox>
                        </b-col>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="6">
                    <b-form-group
                        label-cols-sm="4"
                        :label="$t('createShipment.label.ManualBooking')"
                        label-align-sm="left"
                        name="manualBooking"
                        v-if="this.isAdminOrSuperUser && display(fieldNames.MANUEL_BOOKING)"
                    >
                      <b-input-group size="sm">
                        <b-col sm="10">
                          <b-form-checkbox
                              class="float-left"
                              size="sm"
                              name="brokerCheckbox"
                              v-model="shipment.shipmentOptions.isManualBooking"
                          ></b-form-checkbox>
                        </b-col>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
            </b-col>
        </div>
    </div>
</template>

<script>
import vSelect from './vSelect';
import Datepicker from 'vuejs-datepicker';
import {FIELD_NAMES} from '../store/nameConstants';
import viewOptions from '../mixins/viewOptionsMixin';
import {mapGetters} from 'vuex';
import requiredIcon from './requiredIcon';
import validationField from './Validation/ValidationField';
import {ACTIONS, CREATE_SHIPMENT_PREFIX} from '../store/constants';
import localization from '../mixins/localizationMixin';
import resetMixin from '../mixins/resetMixin';

const insuranceTermsValidation = (value) => {
    return false;
  };
  export default {
      components: {
          vSelect,
          Datepicker,
          requiredIcon,
          validationField,
      },
      mixins: [viewOptions, localization, resetMixin],
      setup() {
        return { $v: this.v};
      },
      props: {
          shipment: { type: Object, required: true },
          v: { required: true },
          additionalFields: { type: Object}
      },
      data() {
          return {
              disabledDates: {
                  days: [6, 0],
              },
              customs: {},
              insurance: {},
              fieldNames: FIELD_NAMES,
              insuranceTermsAccept: false
          };
      },
      validations() {
        return {
          insuranceTermsAccept: {
            insuranceTermsValidation
          }
        };
      },
      watch: {
          'shipment.insuranceAmount': {
              deep: true,
              handler() {
                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
                  );
              },
          },
        'isSoldTo': {
          handler() {
            this.$store.dispatch(
                CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
            );
          },
        },
        'isBroker': {
          handler() {
            this.$store.dispatch(
                CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
            );
          },
        },
          'shipment.customsAmount.amount': {
              handler() {
                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
                  );

                  this.clearCommodities();
              },
          },
          'shipment.customsAmount.currencyCode': {
              handler() {
                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
                  );
                  this.clearCustomsAmount();
                  this.clearCommodities();
              },
          },
          'shipment.receiverPays': {
              deep: true,
              handler() {
                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
                  );
              },
          },
          'shipment.shipmentOptions': {
              deep: true,
              handler() {
                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
                  );
              },
          },
          'shipment.collis': {
              deep: true,
              handler() {
                  let sum = 0;
                  this.shipment.collis.forEach((colli) => {
                    if (colli.unitPrice != null) {
                          sum += colli.unitPrice;
                          if (colli.currency != null) {
                            this.shipment.customsAmount.currencyCode = colli.currency;
                          }
                      }
                  });
                  if (sum != null && sum !== 0) {
                      this.shipment.customsAmount.amount = sum;
                  }
              },
          },
        'defaultShipmentTypeDocument': {
          handler(newValue) {
            this.shipment.shipmentOptions.isDocument = newValue;
          }
        },
          reset() {
              this.shipment.receiverPays = null;
              this.shipment.shipmentOptions.isDocument = false;
              this.shipment.shipmentOptions.notStackablePallet = false;
              this.shipment.shipmentOptions.hasPallet = false;
              this.shipment.shipmentOptions.returnShipment = false;
          },
      },
      computed: {
          displayCustoms(){
            let isCustoms = this.isCustomsShipmentAndNotDocument(
                this.shipment.shipmentOptions.isDocument,
                this.shipment.pickupAddress,
                this.shipment.receiverAddress,
                this.shipment.shipDate
            )
            return isCustoms;
          },
          isInsuranceAcceptRequired() {
            const validation = { required: true };
            if (this.shipment.insuranceAmount != null) {
                if (this.shipment.insuranceAmount.amount > 0) {
                    validation.required = false;
                }
            }
            return validation;
          },
          isInsuranceAmountRequired: {
              get() {
                  return this.$store.state.createShipment.insuranceAmountRequired;
              },
              set(value) {
                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.SET_INSURANCEAMOUNT_REQUIRED,
                      value
                  );

                  this.shipment.insuranceAmount = { amount: 0, currencyCode: '' };
              },
          },
          canInsure() {
            if (this.shipment.shipmentOptions.isDocument) {
              return false;
            }
            return true;
          },

          isReceiverPays: {
              get() {
                  return this.shipment.receiverPays != null;
              },
              set(newValue) {
                  if (newValue) {
                      this.shipment.receiverPays = { transportProduct: null, accountNumber: '' };

                      this.$store.dispatch(
                          CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CHANGE_ISRECEIVERPAYS,
                          newValue
                      );
                  } else {
                      this.shipment.receiverPays = null;

                      this.$store.dispatch(
                          CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CHANGE_ISRECEIVERPAYS,
                          newValue
                      );
                  }
              },
          },

        isSoldTo: {
          get() {
            return this.shipment.soldToAddress != null;
          },
          set(isSoldToChosen) {
            if (isSoldToChosen) {
              if (!this.shipment.soldToAddress) {
                this.$set(this.shipment, 'soldToAddress', this.createEmptyAddress())
              }
            } else {
              this.shipment.soldToAddress = null;
            }
            this.$nextTick(() => this.resetAddressValidation('soldToAddress'))

          }
        },
        isBroker: {
          get() {
            return this.shipment.brokerAddress != null;
          },
          set(isBrokerChosen) {
            if (isBrokerChosen) {
              if (!this.shipment.brokerAddress) {
                this.$set(this.shipment, 'brokerAddress', this.createEmptyAddress())
              }
            } else {
              this.shipment.brokerAddress = null;
            }
            this.$nextTick(() => this.resetAddressValidation('brokerAddress'))

          }
        },

          ...mapGetters('createShipment', [
              'hasBackendValidationError',
              'getListOfInsuranceCurrencies',
              'getReceiverPaysTransportProducts',
              'isCustomsShipment',
              'isCustomsShipmentAndNotDocument',
              'hasShipmentOptions',
              'isDefaultShipmentTypeDocument',
              'defaultShipmentTypeDocument'
          ]),

          ...mapGetters('core', ['getListOfIncoterms', 'getExportReasons', 'getCurrencies', 'isAdminOrSuperUser']),
      },
      created() {
          const today = new Date();
          this.disabledDates.to = today;
          if (this.$route.query.AWB !== undefined) {
            this.disabledDates = {};
          } else {
            this.updateDate(today);
          }
        
      },
      mounted() {
          if (this.display(this.fieldNames.NO_INSURANCE)) {
            this.additionalFields.acceptedInsuranceTerms = true;
          }
        this.shipment.shipmentAmount.currencyCode = this.shipment.customsAmount.currencyCode;
      },
    methods: {
          updateDate(date) {
            const dayOfWeek = date.getDay();

            // Sunday (0) or Saturday (6), increment to Monday (1)
            if (dayOfWeek === 0) {
              date.setDate(date.getDate() + 1);
            }
            // Saturday (6), increment to Sunday (0)
            else if (dayOfWeek === 6) {
              date.setDate(date.getDate() + 2);
            } else {
              date.setDate(date.getDate());
            }
              this.shipment.shipDate = date;
          },

          clearCommodities() {
              if (
                 this.shipment.customsAmount.commodities &&
                  this.shipment.customsAmount.commodities.length > 0 
                  || this.shipment.customsAmount.currencyCode === null
              ) {
                this.shipment.customsAmount.amount = 0
                  this.shipment.customsAmount.commodities = [];
                 
              }
          },
      createEmptyAddress() {
        return {
          name: '',
          street1: '',
          street2: '',
          street3: '',
          city: '',
          postalCode: '',
          countryCode: null,
          stateCode: null,
          accountNumber: '',
          vatNumber: '',
          eoriNumber: '',
          dutyAccountNumber: '',
          contactPerson: { mails: [''] }
        }
      },
      resetAddressValidation(prefix) {
        if (!this.v) return
        if (!this.v.shipment) return

        const node = this.v.shipment[prefix]
        if (!node) return

        node.$reset()
      },

      clearCustomsAmount() {
        if (this.shipment.customsAmount.currencyCode === null) {
          this.shipment.customsAmount.amount = 0
        }
      },
          setIsDocument() {
            this.setDescription();
            this.isInsuranceAmountRequired = true;
          },
          setDescription() {
              this.shipment.texts.description !== 'Legal Documents'
                  ? (this.shipment.texts.description = 'Legal Documents')
                  : (this.shipment.texts.description = '');
          },
      },
  };
</script>
<style></style>
